import React, { useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../Hooks';
import { deleteActivity, getAllActivities } from '../../redux/Actions';

export const Activities = () => {
  const dispatch = useAppDispatch();
  const history = useHistory();

  useEffect(() => {
    dispatch<any>(getAllActivities());
  }, [dispatch]);
  
  let { activities } = useAppSelector((state) => state);
  
  const handleClick = (id: number | undefined, name: string) => {
    dispatch<any>(deleteActivity(id));
    dispatch<any>(getAllActivities());
    alert(`Presiona "Aceptar" si realmente quieres eliminar la Actividad: ${name.toUpperCase()}`);
  };

  const handleReturn = () => {
    history.push("/home");
  };

  return (
    <div className='allActivities__container' >
      <div className='allActivities__container__order' >
        {
          !activities.length ? (
            <p><b>Sin actividad(es)</b></p>
          ) : (
            activities.map((el) => {
              return (
                <div key={el.id} className='allActivities__container__each' >
                  <div>
                    <p>
                      <b>Actividad: </b>
                      {el.name}
                    </p>
                    <p>
                      <b>Duración: </b>
                      {el.duration}
                    </p>
                    <p>
                      <b>Dificultad: </b>
                      {el.difficulty}
                    </p>
                    <p>
                      <b>Temporada: </b>
                      {el.season}
                    </p>
                    <div>
                      <div className="allActivities__container__btns">
                        <div className="allActivities__container__delete">
                          <button
                            onClick={() => handleClick(el.id, el.name)}
                          >
                            ELIMINAR
                          </button>
                        </div>
                        <div className="allActivities__container__edit">
                          <Link to={`/edit-activity/${el.id}`}>
                            <button>EDITAR</button>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })
          )
        }
      </div>
      <div className="allActivities__container__return">
        <button onClick={handleReturn}>
          Regresar
        </button>
      </div>
    </div>
  );
}
